import images from "../../assets/images";

const { errorIcon, successIcon, infoIcon, warningIcon } = images;

export const fetchModalConfig = (type) => {
  switch (type) {
    case "success":
      return {
        modalStyles: {
          boxShadow: "-8px 8px 0px #149e52",
        },
        icon: successIcon,
      };
    case "warn":
      return {
        modalStyles: {
          boxShadow: "-8px 8px 0px #fdce57",
        },
        icon: warningIcon,
      };
    case "info":
      return {
        modalStyles: {
          boxShadow: "-8px 8px 0px #434DF9",
        },
        icon: infoIcon,
      };
    case "error":
      return {
        modalStyles: {
          boxShadow: "-8px 8px 0px #f24326",
        },
        icon: errorIcon,
      };
    default:
      return {
        modalStyles: {
          boxShadow: "-8px 8px 0px #000",
        },
      };
  }
};

// export const displayModal = async (props) => {
//   let result = await confirm("", {
//     render: (title, onOk, onCancel) => (
//       <CommonModal onOk={onOk} onCancel={onCancel} {...props} />
//     ),
//   });

//   if (result) return true;
//   return false;
// };

// export const displayPasswordModal = async () => {
//   let result = await confirm("", {
//     render: (title, onOk, onCancel) => (
//       <PasswordModal
//         onError={(message) => {
//           displayToast({ type: "error", title: message });
//         }}
//         onOk={onOk}
//         onCancel={onCancel}
//       />
//     ),
//   });

//   if (result) return true;
//   return false;
// };
